import script from "./BaseDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDrawer.vue?vue&type=script&setup=true&lang=js"

import "./BaseDrawer.vue?vue&type=style&index=0&id=79101dc6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79101dc6"]])

export default __exports__